/**
 * The DogParks mark.
 *
 * Was a hairline dog head over a pin, hardcoded to `stroke="#0070f3"` — Vercel's default blue,
 * the last surviving piece of the old palette. Loaded as an <img>, it could not inherit a token,
 * so it clashed with every skin by construction.
 *
 * Inline now, so it reads the design system:
 *   - the dog is drawn in `currentColor`, i.e. whatever ink the surrounding chrome uses
 *   - the pin is the marker red (--c-primary), the system's single saturated colour
 *
 * That is the same rule the whole site follows: red means "here". The map marker, the micro-map
 * glyph on every park card, and the logo are now one idea stated three times, rather than three
 * unrelated marks.
 */
export default function BrandMark({ size = 28, className }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {/* dog: inherits the chrome's ink */}
      <circle cx="32" cy="26" r="10" />
      <path d="M 24 18 Q 22 12 20 14" />
      <path d="M 40 18 Q 42 12 44 14" />
      <ellipse cx="32" cy="30" rx="4" ry="3" />
      <circle cx="29" cy="24" r="1.4" fill="currentColor" stroke="none" />
      <circle cx="35" cy="24" r="1.4" fill="currentColor" stroke="none" />

      {/* the marker: the one saturated colour in the system */}
      <path
        d="M 32 42 C 26 48 20 50 20 50 L 32 62 L 44 50 C 44 50 38 48 32 42 Z"
        stroke="var(--c-primary)"
        fill="color-mix(in srgb, var(--c-primary) 14%, transparent)"
      />
    </svg>
  )
}
